import { apiClient } from '@/lib/api-client';
import type { ApiSuccess } from '@/lib/api-client';
import type {
  MassBalanceViewDto,
  ReconciliationResultDto,
  ReconciliationSnapshotDto,
} from './types';

export const fetchMassBalance = async (batchId: string): Promise<MassBalanceViewDto> => {
  const res = await apiClient.get<ApiSuccess<MassBalanceViewDto>>(
    `/monthly-batches/${batchId}/mass-balance`,
  );
  return res.data.data;
};

export const fetchSnapshotHistory = async (
  batchId: string,
): Promise<ReconciliationSnapshotDto[]> => {
  const res = await apiClient.get<ApiSuccess<ReconciliationSnapshotDto[]>>(
    `/monthly-batches/${batchId}/reconciliation-snapshots`,
  );
  return res.data.data;
};

export const runReconciliation = async (batchId: string): Promise<ReconciliationResultDto> => {
  const res = await apiClient.post<ApiSuccess<ReconciliationResultDto>>(
    `/monthly-batches/${batchId}/run-reconciliation`,
  );
  return res.data.data;
};

export const requestClose = async (batchId: string): Promise<void> => {
  await apiClient.post(`/monthly-batches/${batchId}/request-close`);
};

export const closeBatch = async (batchId: string): Promise<void> => {
  await apiClient.post(`/monthly-batches/${batchId}/close`);
};
